const endpoints = {
  accounts: {
    base: 'consumer-site/accounts/v2/:id',
    create: 'consumer-site/accounts/v2',
    userInfo: 'consumer-site/accounts/v2/user-info',
    deleteProfile: 'consumer-site/accounts/v2/request-deletion',
  },
  carts: {
    cart: 'consumer-site/carts/v2/:id',
  },
  checkout: {
    pay: {
      credit: 'checkout/pay/credit',
    },
    upsertCustomer: 'v3/consumer-site/checkout',
  },
  cms: {
    base: 'https://api.buttercms.com/v2',
    collection: '/api/cms/collection',
    link: '/api/cms/link',
    pages: 'pages/:slug', //?auth_token=your_token',
    retrieve: '/api/cms/retrieve',
    search: '/api/cms/search',
  },
  twilio: {
    lookup:
      'communications/validate/phone-number/:phoneNumber/country-code/:countryCode',
  },
  locations: {
    byIP: 'https://ipapi.co/json',
  },
  events: {
    byLot: 'consumer-site/events/v2/lot/:lotId',
    search: 'consumer-search/lot',
  },
  invoices: {
    finalize: 'invoices/v2/:id/finalize/:tip',
    quote: {
      accept: 'invoices/v2/quote/:id/accept',
      create: 'invoices/v2/quote',
      edit: 'invoices/v2/quote/:id/edit',
    },
    tip: 'invoices/v2/:id/tip/:tip',
  },
  orders: {
    base: 'orders/v2/:id',
    like: 'orders/like/:id',
    pickup: 'orders/pickup',
    promo: 'consumer-site/orders/v2/promo/:code',
    remove: 'orders/remove/:id',
    search: 'consumer-site/order-search/v2/consumer',
    transactions: 'orders/transactions',
  },
  organizations: {
    get: 'v3/consumer-site/organizations/:slug',
    territories: 'consumer-site/territories/v2',
  },
  products: {
    base: 'products/:id/:includeSchedule',
    search: 'consumer-search/product',
  },
  sites: {
    organizationProfile: {
      getByDomain: 'v3/sites/organization-site-profiles/domain/{domain}',
      getBySubdomain:
        'v3/sites/organization-site-profiles/sub-domain/{subdomain}',
    },
  },
  stripe: {
    card: 'customers/card',
  },
  vendors: {
    base: 'consumer-site/vendors/v2/:id',
    get: 'v3/consumer-site/vendors/:slug',
    menu: 'menu/:id',
    orgMenu: 'consumer-site/menu/v2/:id',
    orderingSchedules: 'consumer-search/vendor',
    products: 'menu/vendor/:vendorId',
    searchAll: 'consumer-search/vendor/all',
  },
  likes: {
    base: 'likes',
    delete: 'likes/entity/:entityId/type/:entityType',
    likedVendors: 'likes/vendors',
  },
  lots: {
    base: 'public/lots/v2/:id',
  },
  schedules: {
    base: 'public/schedules/v2/:id',
  },
};

export default endpoints;
